<script>
export default {
   inserted: function (el) {
        var headers = el.getElementsByClassName('header-item');
        var sections = el.getElementsByClassName('items');
        var setOnclick = function(ctl, id) {
            ctl.onclick = function() {
                for(var i = 0; i < headers.length; i++) {
                    headers[i].classList.remove('active');
                    sections[i].classList.remove('active');
                }
                headers[id].classList.add('active');
                sections[id].classList.add('active');
                return false;
            }
        }
        for(var i = 0; i < headers.length; i++) {
            setOnclick(headers[i], i);
        }


        var setVehicleClick = function(el) {
            el.getElementsByClassName('social-img')[0].onclick = function() {
                el.classList.add('show-popup')
            }
            el.getElementsByClassName('popup')[0].onclick = function() {
                el.classList.remove('show-popup')
            }
        }

        var vehicles = el.getElementsByClassName('vehicle');
        for(var i = 0; i < vehicles.length; i++) {
            setVehicleClick(vehicles[i]);
        }
   }
}
</script>